import { defaultsDeep } from 'lodash';
import { muiThemeLuma } from 'themes';

const getPropsLumaLegacy = (theme, defaults) => {
  const {
    custom: {
      palette: { colorSupportSteel },
    },
    palette: {
      common: { white },
      primary,
      secondary,
      text,
    },
    spacing: { unit },
    zIndex: { tooltip },
  } = theme;

  return defaultsDeep(
    {},
    {
      themeName: 'Luma Legacy',
      overrides: {
        MuiButton: {
          containedSecondary: {
            color: white,
            '&$focused': {
              color: secondary.light,
            },
            '&:hover': {
              backgroundColor: secondary.light,
            },
          },
        },
        MuiFormControl: {
          root: {
            marginTop: 17,
          },
        },
        MuiFormHelperText: {
          error: {},
          root: {
            fontFamily: muiThemeLuma.typography.fontFamily,
            fontSize: 10,
            fontWeight: 500,
          },
        },
        MuiInput: {
          disabled: {},
          error: {},
          focused: {},
          input: {
            color: text.primary,
            fontFamily: muiThemeLuma.typography.fontFamily,
            fontWeight: 500,
            padding: '6px 0px 6px',
          },
          underline: {
            '&:hover:not($disabled):not($focused):not($error):before': {
              borderBottom: '1px solid #e0e0e0',
            },
            '&:before': {
              borderBottom: '1px solid #e0e0e0',
            },
            '&:after': {
              borderBottom: `2px solid ${text.primary}`,
            },
          },
        },
        MuiInputBase: {
          input: {
            '&.Select.Select--single .Select-control': {
              height: '30px !important',
            },
            '&.Select.has-value.Select--single > .Select-control .Select-value': {
              padding: `${unit * 2}px ${unit * 2}px ${unit * 2}px 0px !important`,
            },
            '&.Select.Select--single > .Select-control .Select-placeholder': {
              padding: `${unit * 2}px ${unit * 2}px ${unit * 2}px 0px !important`,
            },
            '& .Select-input input': {
              padding: '0px !important',
            },
            '& .Select-multi-value-wrapper': {
              padding: `${unit / 2}px ${unit * 5}px ${unit / 2}px 0px !important`,
            },
            '&.Select.Select--single .Select-control > *:last-child': {
              paddingRight: 0,
              paddingTop: unit / 2,
            },
          },
        },
        MuiInputLabel: {
          error: {},
          focused: {},
          formControl: {
            fontFamily: muiThemeLuma.typography.fontFamily,
            fontSize: 14,
            fontWeight: 500,
            transform: 'translate(0px, 24px) scale(1)',
          },
          root: {
            color: text.secondary,
            fontSize: 14,
            fontWeight: 500,
            '&$error': {
              color: text.secondary,
            },
            '&$error$focused': {
              color: text.secondary,
            },
          },
          shrink: {
            fontSize: 14,
            fontWeight: 500,
            '&$focused': {
              color: text.secondary,
            },
          },
        },
        MuiInputAdornment: {
          root: {
            color: colorSupportSteel,
          },
        },
        MuiModal: {
          root: {
            zIndex: tooltip,
          },
        },
      },
    },
    defaults,
  );
};

export default getPropsLumaLegacy;
